import { hasRole } from "@shelflist/shared";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { NoPermission } from "@/components/no-permission";
import { SectionNav } from "@/components/section-nav";
import { usePendingUploadCount } from "@/lib/queries";
import { useMe } from "@/lib/session";

/** Layout for the upload pages: editors and admins only (the API enforces the same rule). */
export const Route = createFileRoute("/_app/upload")({
  component: UploadLayout,
});

function UploadLayout() {
  const me = useMe();
  const { t } = useTranslation(["upload", "common"]);
  const allowed = hasRole(me, "editor");
  const pending = usePendingUploadCount(allowed);
  if (!allowed) return <NoPermission />;
  return (
    <div className="grid gap-6">
      <SectionNav
        variant="tabs"
        label={t("tabs.label")}
        items={[
          { to: "/upload", label: t("tabs.upload"), exact: true },
          {
            to: "/upload/inbox",
            label: t("tabs.inbox"),
            badge: pending,
            badgeLabel: t("common:nav.uploadCount", { count: pending }),
          },
        ]}
      />
      <Outlet />
    </div>
  );
}
